module.exports = __webpack_public_path__ + "static/media/sidebar-5.08efb632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-5.jpg
// module id = 362
// module chunks = 0